
export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-red-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-yellow-400 mb-4">
            CONTATO
          </h2>
          <div className="w-24 md:w-32 h-2 bg-yellow-400 mx-auto rounded-full"></div>
          <p className="text-white text-base md:text-xl mt-4 md:mt-6">Fale conosco e tire suas dúvidas!</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-start">
          {/* Info cards */}
          <div className="space-y-4 md:space-y-8">
            <div className="bg-white rounded-2xl p-5 md:p-8 shadow-xl transform hover:scale-105 transition-all duration-300">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-fill text-2xl md:text-3xl text-yellow-400"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-xl font-bold text-black mb-1 md:mb-2">WhatsApp</h3>
                  <p className="text-gray-600 text-sm md:text-base mb-2 md:mb-3">Faça seu pedido ou tire dúvidas</p>
                  <a
                    href="https://wa.me/5519971394274"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-green-600 font-bold hover:text-green-700 flex items-center gap-2 text-sm md:text-base cursor-pointer"
                  >
                    (19) 97139-4274
                    <i className="ri-external-link-line"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-5 md:p-8 shadow-xl transform hover:scale-105 transition-all duration-300">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-instagram-fill text-2xl md:text-3xl text-yellow-400"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-xl font-bold text-black mb-1 md:mb-2">Instagram</h3>
                  <p className="text-gray-600 text-sm md:text-base mb-2 md:mb-3">Acompanhe nossas novidades</p>
                  <a
                    href="https://www.instagram.com/buckets.chicken"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-pink-600 font-bold hover:text-pink-700 flex items-center gap-2 text-sm md:text-base cursor-pointer"
                  >
                    @buckets.chicken
                    <i className="ri-external-link-line"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-5 md:p-8 shadow-xl transform hover:scale-105 transition-all duration-300">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-fill text-2xl md:text-3xl text-yellow-400"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-xl font-bold text-black mb-1 md:mb-2">Horário</h3>
                  <p className="text-gray-600 text-sm md:text-base mb-1 md:mb-2">Segunda a Domingo</p>
                  <p className="text-red-600 font-bold text-base md:text-lg">11:00 - 23:00</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-5 md:p-8 shadow-xl transform hover:scale-105 transition-all duration-300">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-fill text-2xl md:text-3xl text-yellow-400"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-xl font-bold text-black mb-1 md:mb-2">Localização</h3>
                  <p className="text-gray-600 text-sm md:text-base">Rua José Pedro de Oliveira, 177 B</p>
                  <p className="text-red-600 font-bold mt-1 text-sm md:text-base">Paulínia/SP</p>
                </div>
              </div>
            </div>
          </div>

          {/* Formulário */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-xl">
            <h3 className="text-xl md:text-2xl font-black text-black mb-5 md:mb-6">Envie uma Mensagem</h3>
            <form className="space-y-4 md:space-y-6">
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">Nome</label>
                <input
                  type="text"
                  className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-red-600 focus:outline-none transition-colors text-sm md:text-base"
                  placeholder="Seu nome completo"
                />
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">WhatsApp</label>
                <input
                  type="tel"
                  className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-red-600 focus:outline-none transition-colors text-sm md:text-base"
                  placeholder="(11) 99999-9999"
                />
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">Mensagem</label>
                <textarea
                  rows={5}
                  className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-red-600 focus:outline-none transition-colors resize-none text-sm md:text-base"
                  placeholder="Como podemos ajudar?"
                  maxLength={500}
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-red-600 text-white py-3 md:py-4 rounded-lg font-bold text-base md:text-lg hover:bg-red-700 transition-all duration-300 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-fill text-lg md:text-xl"></i>
                Enviar Mensagem
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-16 md:mt-24 pt-8 md:pt-12 border-t-2 border-yellow-400">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-3 md:gap-4">
              <img
                src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/a5bb4558efa960a1896a0fe4ecddc296.png"
                alt="Buckets Chicken"
                className="h-12 w-12 md:h-16 md:w-16 object-contain"
              />
              <div>
                <h4 className="text-xl md:text-2xl font-black text-yellow-400">BUCKETS CHICKEN</h4>
                <p className="text-white text-xs md:text-sm">O melhor frango frito da cidade!</p>
              </div>
            </div>

            <div className="flex gap-3 md:gap-4">
              <a
                href="https://www.instagram.com/buckets.chicken"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 md:w-12 md:h-12 bg-yellow-400 rounded-full flex items-center justify-center hover:bg-yellow-300 transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-instagram-fill text-xl md:text-2xl text-black"></i>
              </a>
              <a
                href="https://wa.me/5519971394274"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 md:w-12 md:h-12 bg-yellow-400 rounded-full flex items-center justify-center hover:bg-yellow-300 transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl text-black"></i>
              </a>
            </div>
          </div>

          <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-yellow-400/30 text-center">
            <p className="text-white text-xs md:text-sm">
              © 2026 Buckets Chicken. Todos os direitos reservados.{' '}
              Site Criado por{' '}
              <a
                href="https://guepardosites.link"
                target="_blank"
                rel="noopener noreferrer"
                className="text-yellow-400 hover:text-yellow-300 font-bold transition-colors duration-300 cursor-pointer"
              >
                guepardosites.link
              </a>
            </p>
          </div>
        </div>
      </footer>
    </section>
  );
}
